// Partner ads (Video Poker Analyzer). See app/helpers/video_poker_analyzer_helper.rb
//
// Each <div class="vpa-slot"> carries its creatives (desktop + mobile) as data attributes.
// On every page load we pick a creative per slot (rotating, so a page doesn't repeat one
// until it runs out), insert the link + image, and report to Google Analytics (GA4):
//   vpa_view  - slot was at least 50% visible for 1 second (counted once per page view)
//   vpa_click - creative was clicked
// both with params vpa_creative (= utm_id) and vpa_slot. CTR = vpa_click / vpa_view.

const MOBILE = '(max-width: 47.99em)'  // below pure-grid "md"
const VIEW_MS = 1000

function track(name, a) {
  if (typeof window.gtag !== 'function') return
  window.gtag('event', name, {
    vpa_creative: a.dataset.vpaCreative,
    vpa_slot: a.dataset.vpaSlotName,
    transport_type: 'beacon'
  })
}

function watchViews(links) {
  if (!('IntersectionObserver' in window)) {
    links.forEach(a => track('vpa_view', a))
    return
  }
  const timers = new Map()
  const observer = new IntersectionObserver(entries => {
    entries.forEach(e => {
      const a = e.target
      if (e.isIntersecting) {
        timers.set(a, setTimeout(() => {
          track('vpa_view', a)
          observer.unobserve(a)
        }, VIEW_MS))
      } else {
        clearTimeout(timers.get(a))
      }
    })
  }, { threshold: 0.5 })
  links.forEach(a => observer.observe(a))
}

function fillSlots() {
  const slots = document.querySelectorAll('.vpa-slot:not([data-vpa-filled])')
  if (slots.length === 0) return

  const mobile = window.matchMedia(MOBILE).matches
  const next = {}  // pool (creative ids) -> rotating index, random start per page
  const links = []

  slots.forEach(slot => {
    const pool = JSON.parse(slot.dataset[mobile ? 'vpaMobile' : 'vpaDesktop'])
    const key = pool.map(c => c.id).join()
    if (!(key in next)) next[key] = Math.floor(Math.random() * pool.length)
    const c = pool[next[key]++ % pool.length]
    const square = /^mobile-/.test(c.id)

    const a = document.createElement('a')
    a.href = c.href
    a.target = '_blank'
    a.rel = 'sponsored noopener'
    a.dataset.vpaCreative = c.id
    a.dataset.vpaSlotName = slot.dataset.vpaSlot
    a.style.display = 'inline-block'
    a.style.maxWidth = '100%'

    const img = document.createElement('img')
    img.src = c.src
    img.alt = 'Video Poker Analyzer'
    img.style.display = 'block'
    img.style.maxWidth = '100%'
    if (square) {
      img.style.width = '300px'
    } else {
      img.style.maxHeight = '150px'
      img.style.width = 'auto'
    }

    a.appendChild(img)
    a.addEventListener('click', () => track('vpa_click', a))
    slot.appendChild(a)
    slot.dataset.vpaFilled = '1'
    links.push(a)
  })

  watchViews(links)
}

document.addEventListener('turbolinks:load', fillSlots)
